import { render, staticRenderFns } from "./cancelVacation.vue?vue&type=template&id=206e583c&scoped=true&"
import script from "./cancelVacation.vue?vue&type=script&lang=js&"
export * from "./cancelVacation.vue?vue&type=script&lang=js&"
import style0 from "./cancelVacation.vue?vue&type=style&index=0&id=206e583c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206e583c",
  null
  
)

export default component.exports